import type { QueryKey } from '@tanstack/react-query';
import type { ReceiptBatchListParams } from './api';

export const RECEIPT_BATCH_LIST_PHOENIX_KEY = (
  params?: ReceiptBatchListParams
): QueryKey => {
  if (params) {
    return ['receipt-batch-list-phoenix', params];
  }
  return ['receipt-batch-list-phoenix'];
};

export const RECEIPT_BATCH_PHOENIX_KEY = (id: string | undefined): QueryKey => {
  return ['receipt-batch-phoenix', id ?? '--'];
};
